import { BASE_DOMAIN } from "@/lib/config";
import { normalizeCountryCode } from "@/lib/country-normalize";
import { countryCodeToEmoji } from "@/lib/flags";

export function formatProfileCount(count: number): string {
  if (count >= 1000) {
    return (count / 1000).toLocaleString("en-US", { maximumFractionDigits: 1 }) + "k";
  }
  return count.toLocaleString("en-US");
}

// ADR_LISTING_SHIP_FROM_ADDRESS Phase 2: `countryFromListingLocation` and
// `dominantCountry` were deleted — the profile country chip now reads
// `seller.country` (the seller's `address_book.is_main.country` ISO-2) which
// is hydrated server-side in `app/(site)/[username]/page.tsx`. The prior
// heuristic of guessing dominant country from the last comma-segment of
// free-text `location` no longer matches a real data source.

export function countryNameToFlagEmoji(countryName: string): string {
  const trimmed = (countryName ?? "").trim();
  if (!trimmed) return "";
  const code = normalizeCountryCode(trimmed);
  if (!code || code.length !== 2) return "";
  return countryCodeToEmoji(code);
}

export function profilePrimaryName(input: {
  username: string | null | undefined;
  displayName?: string | null;
}): string {
  const handle = (input.username ?? "").trim();
  const rawDisplay = input.displayName?.trim() ?? "";
  const hasDistinct =
    rawDisplay.length > 0 && rawDisplay.toLowerCase() !== handle.toLowerCase();
  return hasDistinct ? rawDisplay : handle;
}

export function parseListingImageUrls(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw.filter((item): item is string => typeof item === "string");
  }
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw || "[]") as unknown;
      return Array.isArray(parsed)
        ? parsed.filter((item): item is string => typeof item === "string")
        : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function profileShareUrl(username: string | null | undefined): string {
  const handle = (username ?? "").replace(/^@+/, "").trim();
  if (!handle) return BASE_DOMAIN;
  return `${BASE_DOMAIN}/${encodeURIComponent(handle)}`;
}
